<template>
  <el-tabs value="tab1" type="card" @tab-click="changeTab">
    <el-tab-pane label="测试台产品" name="tab1">
      <material-standard-mapping-list ref="tabBox"/>
    </el-tab-pane>
     <el-tab-pane label="COP程序维护" name="tab2">
      <cop-material-list ref="tabCop"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import MaterialStandardMappingList from "@/views/information/MaterialStandardMapping/MaterialStandardMappingList.vue";
  import CopMaterialList from "@/views/information/MaterialStandardMapping/CopMaterialList.vue";

  export default {
    name: "MaterialStandardMappingTabs",
    components: {MaterialStandardMappingList,CopMaterialList},
    methods:{
      changeTab(name){
        if(name == "tab1"){
          this.$refs.tabBox.getList(1);
        }
        else if(name == "tab2"){
          this.$refs.tabCop.getList(1);
        }
      },
    },
  };
</script>

<style scoped lang="scss">

</style>